import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` } });
export const money = (n) => `${Number(n || 0) < 0 ? "-" : ""}$${Math.abs(Number(n || 0)).toFixed(2)}`;
export const newKey = () => `stl_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
export const errDetail = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return { message: d };
  return d || { message: "Something went wrong — please try again" };
};

const S = `${API}/admin/settlement`;
export const settle = {
  summary: (id) => axios.get(`${S}/booking/${id}`, auth()).then((r) => r.data),
  group: (gid) => axios.get(`${S}/group/${encodeURIComponent(gid)}`, auth()).then((r) => r.data),
  timeline: (id) => axios.get(`${S}/booking/${id}/timeline`, auth()).then((r) => r.data.events),
  preview: (id, body) => axios.post(`${S}/booking/${id}/preview`, body, auth()).then((r) => r.data),
  commit: (id, body) => axios.post(`${S}/booking/${id}/commit`, body, auth()).then((r) => r.data),
  commitDoc: (key) => axios.get(`${S}/commits/${encodeURIComponent(key)}`, auth()).then((r) => r.data),
  cancel: (key, reason) => axios.post(`${S}/commits/${encodeURIComponent(key)}/cancel`, { reason }, auth()).then((r) => r.data),
  attention: () => axios.get(`${S}/attention`, auth()).then((r) => r.data),
  groupPreview: (gid, body) => axios.post(`${S}/group/${encodeURIComponent(gid)}/preview`, body, auth()).then((r) => r.data),
  groupCommit: (gid, body) => axios.post(`${S}/group/${encodeURIComponent(gid)}/commit`, body, auth()).then((r) => r.data),
  emailPreview: (params) => axios.get(`${S}/email/preview`, { ...auth(), params }).then((r) => r.data),
  emailSend: (body) => axios.post(`${S}/email/send`, body, auth()).then((r) => r.data),
  customerSummary: (email) => axios.get(`${S}/customer-summary`, { ...auth(), params: { email } }).then((r) => r.data),
};

const C = `${API}/admin/rental-credits`;
export const credits = {
  list: (email) => axios.get(C, { ...auth(), params: email ? { customer_email: email } : {} }).then((r) => r.data.credits),
  settings: () => axios.get(`${C}/settings`, auth()).then((r) => r.data),
  saveSettings: (body) => axios.put(`${C}/settings`, body, auth()).then((r) => r.data),
  analytics: () => axios.get(`${C}/analytics`, auth()).then((r) => r.data),
  issue: (body) => axios.post(`${C}/issue`, body, auth()).then((r) => r.data),
  redeem: (id, body) => axios.post(`${C}/${id}/redeem`, body, auth()).then((r) => r.data),
  cancel: (id, reason) => axios.post(`${C}/${id}/cancel`, { reason }, auth()).then((r) => r.data),
};

export const COLLECTION_MODES = [
  { value: "bond_deduction", label: "Take from bond" },
  { value: "external_paid", label: "Paid externally (cash / bank)" },
  { value: "external_pending", label: "To be paid externally" },
  { value: "stripe_saved_card", label: "Charge saved card" },
  { value: "stripe", label: "Send Stripe payment link" },
];
export const PAY_METHODS = [
  { value: "bank_transfer", label: "Bank transfer" },
  { value: "eftpos", label: "EFTPOS" },
  { value: "cash", label: "Cash" },
  { value: "other", label: "Other" },
];
export const CHARGE_TYPES = [
  { value: "late_fee", label: "Late fee" },
  { value: "damage", label: "Damage / repair" },
  { value: "cleaning", label: "Cleaning" },
  { value: "missing", label: "Missing item" },
  { value: "other", label: "Other" },
];
export const BOND_ACTIONS = [
  { value: "none", label: "No bond change" },
  { value: "full_refund", label: "Refund all remaining bond" },
  { value: "partial_refund", label: "Refund part of the bond" },
  { value: "partial_deduction", label: "Keep part, refund part" },
  { value: "full_deduction", label: "Keep all remaining bond" },
];
export const COLLECTION_STATUSES = [
  { value: "", label: "No change" },
  { value: "collected", label: "Collected" },
  { value: "not_collected", label: "Never collected" },
  { value: "returned", label: "Returned on time" },
  { value: "returned_late", label: "Returned late" },
];
export const STATUS_STYLE = {
  settled: "bg-emerald-50 text-emerald-700 border-emerald-200",
  outstanding: "bg-amber-50 text-amber-700 border-amber-200",
  refund_or_credit_due: "bg-sky-50 text-sky-700 border-sky-200",
  bond_open: "bg-stone-50 text-stone-700 border-stone-200",
  settlement_failed: "bg-red-50 text-red-700 border-red-200",
  settlement_pending: "bg-orange-50 text-orange-700 border-orange-200",
};
export const statusLabel = (s) => (s || "").replace(/_/g, " ");
